export interface ICompanyEditSaveSuccess {
    id: string;
    rowId: string;
    message: string;
    styleChanged: boolean;
}

export class CompanyEditSaveSuccess implements ICompanyEditSaveSuccess {
    id: string;
    rowId: string;
    message: string;
    styleChanged: boolean;

    constructor();
    constructor(obj: ICompanyEditSaveSuccess);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.rowId = obj && obj.rowId || "";
        this.message = obj && obj.message || "";
        this.styleChanged = obj && obj.styleChanged || false;
    }
}